import { Component, OnDestroy, OnInit, Input} from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
//import { GridOptions, ColDef } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from "ag-grid-community";

import { Observable, Subscription, forkJoin } from "rxjs";
import { filter, map, mergeMap, tap } from "rxjs/operators";

import { FlowIndex } from "../../../../common/models/flow.dto"
import { FlowInstanceService } from '../../../../flow/services/flow-instance.service';
import { RouterLinkRendererComponent } from '../../../../common/components/ag-grid/router-link-renderer.component';
import { ModalInfoComponent } from "../../../../common/components/ag-grid/modal-info.component";
import { dateComparator } from '../../../../common/components/data-table/comparators/data-table.comparators';
import { GridFormatterService } from '../../../../common/services/grid-formatter.service';
import { AuthService } from "../../../../services/auth.service";
import { TabComponent } from '../../../../common/components/tabs/tab.component';
import { ContactStub } from '../../../../admin/models/contact.model';
import { Group } from '../../../../admin/models/group.model';
import { GroupSearchSpec, GroupService } from '../../../../admin/services/group.service';
import { PendingFlow } from '../../../../flow/models/flow.model';
import { PendingWorkOrderAssignment, WorkOrderStatus, WorkOrderType } from '../../../../common/models/work-order.model';
import { WorkOrderService } from '../../../../common/services/work-order.service';
import { ViewBase } from '../view-base';
import { LunaClaimValues } from '../../../../models/user-identity.model';
import { PermitService } from '../../../../common/services/permit.service';
import { WorkOrderSearchSpec } from '../../../../models/work-order-search-spec.model';

@Component({
    selector: 'pending-well-transfer-widget',
    templateUrl: './pending-well-transfer-widget.component.html',
    styleUrls: ['./pending-well-transfer-widget.component.scss'],
    standalone: false
})
export class PendingWellTransferWidgetComponent extends ViewBase implements OnInit, OnDestroy {
    @Input() widgetTitle: string;


    notSubmittedData: FlowIndex[];
    pendingData: PendingFlow[];
    inspectionData: PendingFlow[];
    firstReviewData: PendingFlow[];
    finalReviewData: PendingFlow[];
    approvedData: PendingFlow[];
    deniedData: PendingFlow[];
	notSubmittedGridOptions: GridOptions;
	notSubmittedGridApi?: GridApi;
	pendingGridOptions: GridOptions;
	pendingGridApi?: GridApi;
	inspectionGridOptions: GridOptions;
	inspectionGridApi?: GridApi;
	firstReviewGridOptions: GridOptions;
	firstReviewGridApi?: GridApi;
	finalReviewGridOptions: GridOptions;
	finalReviewGridApi?: GridApi;
	approvedGridOptions: GridOptions;
	approvedGridApi?: GridApi;
	deniedGridOptions: GridOptions;
	deniedGridApi?: GridApi;
    subscriptions: Subscription = new Subscription();
    statusEnum = WorkOrderStatus;
    workOrderTypeEnum = WorkOrderType;
    types: any;

    allUsers: ContactStub[] = [];
    groups: Group[] = [];
    inspectionFilteredUsers: ContactStub[] = [];
    firstReviewFilteredUsers: ContactStub[] = [];
    finalReviewFilteredUsers: ContactStub[] = [];
    pendingReviewFilteredUsers: ContactStub[] = [];

    constructor(
        public workOrderService: WorkOrderService,
        public readonly flowService: FlowInstanceService,
        private formatterService: GridFormatterService,
        private router: Router,
        private auth: AuthService,
        public groupService: GroupService
    ) {
        super("ViewPendingWellTransferWidget", [LunaClaimValues.ViewPendingWellTransferWidget]);
    }

    ngOnInit() {
        this.types = [
            WorkOrderType.AdHoc,
            WorkOrderType.AdHocReview,
            WorkOrderType.Permit,
            WorkOrderType.Review,
            WorkOrderType.ReviewExpedite,
            WorkOrderType.AcceptApplication,
            WorkOrderType.Resubmit
        ];
        this.refreshData();
        this.setGridOptions();
        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.subscriptions.unsubscribe();
        });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    transferorColumn = {
        headerClass: "wrapped",
        headerName: "Transferor",
        headerTooltip: "Transferor",
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams,
        field: "transfererCompanyName",
        tooltipField: "transfererCompanyName",
        minWidth: 130,
        maxWidth: 150
    } as ColDef;

    transfereeColumn = {
        headerClass: "wrapped",
        headerName: "Transferee",
        headerTooltip: "Transferee",
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams,
        field: "transfereeCompanyName",
        tooltipField: "transfereeCompanyName",
        minWidth: 130,
        maxWidth: 150
    } as ColDef;

    dateCreatedColumn = {
        headerClass: "wrapped",
        comparator: dateComparator,
        headerName: "Created",
        headerTooltip: "Created",
        field: "createdDate",
        tooltipValueGetter: this.formatterService.formatDate("createdDate"),
        valueGetter: this.formatterService.formatDate("createdDate"),
        filter: "agDateColumnFilter",
        filterParams: this.formatterService.defaultDateFilterParams,
        sort: "desc",
        sortingOrder: ["asc", null, "desc"],
        minWidth: 150,
        maxWidth: 200
    } as ColDef;

    dateApprovedColumn = {
        headerClass: "wrapped",
        comparator: dateComparator,
        headerName: "Approved",
        headerTooltip: "Approved",
        field: "modifiedDate",
        tooltipValueGetter: this.formatterService.formatDate("modifiedDate"),
        valueGetter: this.formatterService.formatDate("modifiedDate"),
        filter: "agDateColumnFilter",
        filterParams: this.formatterService.defaultDateFilterParams,
        minWidth: 150,
        maxWidth: 200
    } as ColDef;

    dateDeniedColumn = {
        headerClass: "wrapped",
        comparator: dateComparator,
        headerName: "Denied",
        headerTooltip: "Denied",
        field: "modifiedDate",
        tooltipValueGetter: this.formatterService.formatDate("modifiedDate"),
        valueGetter: this.formatterService.formatDate("modifiedDate"),
        filter: "agDateColumnFilter",
        filterParams: this.formatterService.defaultDateFilterParams,
        minWidth: 150,
        maxWidth: 200
    } as ColDef;

    applicationNumberWithLinkInspectionColumn = {
        headerClass: "wrapped",
        headerName: "Application Number",
        headerTooltip: "Application Number",
        field: 'flowIdentifier',
        tooltipField: 'flowIdentifier',
        cellRenderer: RouterLinkRendererComponent,
        cellRendererParams: {
            textField: 'flowIdentifier',
            openInNewWindow: false,
            url: (data: FlowIndex) => {
                const prefix = (data.isEndState) === false ? "/flow/review" : "/flow";

                const suffix = (data.isEndState) === false ? "" : data.currentWorkItemId;
                return `${prefix}/${data.flowId}/${suffix}`;
            }   
        },     
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams,
        minWidth: 170,
        maxWidth: 200
    } as ColDef;

    applicationNumberWithLinkColumn = {
        headerClass: "wrapped",
        headerName: "Application Number",
        headerTooltip: "Application Number",
        field: 'flowIdentifier',
        tooltipField: 'flowIdentifier',
        cellRenderer: RouterLinkRendererComponent,
        cellRendererParams: { textField: "flowIdentifier", flowIdField: "flowId", workItemIdField: "currentWorkItemId" },        
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams,
        minWidth: 170,
        maxWidth: 200
    } as ColDef;

    appTypeColumn: ColDef = {
        headerClass: "wrapped",
        editable: false,
        headerName: 'Application Type',
        headerTooltip: 'Application Type',
        field: 'name',
        tooltipField: 'name',
        minWidth: 150,
        maxWidth: 200,
    } as ColDef;

    relatedApplicationColumn: ColDef = {
        headerClass: "wrapped",
        editable: false,
        headerName: 'Well Transfer Application Number',
        headerTooltip: 'Well Transfer Application Number',
        field: 'originalApplicationNumber',
        tooltipField: 'originalApplicationNumber',
        minWidth: 150,
        maxWidth: 200,
    } as ColDef;

    inspectionStatusColumn: ColDef = {
        headerClass: "wrapped",
        editable: false,
        headerName: 'Inspection Status',
        headerTooltip: 'Inspection Request #',
        field: 'status',
        tooltipField: 'status',
        tooltipValueGetter: this.statusFormatter(),
        valueGetter: this.statusFormatter(),
        minWidth: 150,
        maxWidth: 200,
    } as ColDef;

    statusFormatter() {
        return (obj: any) => Number(this.statusEnum[obj.data.status]) === 0 ? "Pending" : "Complete";
    }

    workOrderTypeFormatter() {
        return (obj: any) => this.prettyGridWorkOrderTypes[obj.data.type];
    }

    prettyGridWorkOrderTypes = [
        "Ad Hoc",
        "Permit",
        "Review",
        "Ad Hoc Review",
        "Review Expedite",
        "Accept Application",
        "Certified Mail",
        "StandardMail",
        "Scan Documents",
        "Resubmit"
    ];
    
    public notSubmittedColDefs() {
        return [
            this.dateCreatedColumn,
            {
                headerClass: "wrapped",
                headerName: "Application Number",
                headerTooltip: "Application Number",
                field: 'flowIdentifier',
                tooltipField: 'flowIdentifier',
                filter: "agTextColumnFilter",
                filterParams: this.formatterService.defaultTextFilterParams,
                minWidth: 170,
                maxWidth: 200
            },
            this.transferorColumn,
            this.transfereeColumn,
            this.appTypeColumn
        ] as ColDef[];
    }

    public pendingColDefs() {
        return [
            {
                headerClass: "wrapped",
                headerName: "Submitted",
                headerTooltip: "Submitted",
                field: "dateSubmitted",
                tooltipValueGetter: this.formatterService.formatDate("dateSubmitted"),
                valueGetter: this.formatterService.formatDate("dateSubmitted"),
                comparator: dateComparator,
                filter: "agDateColumnFilter",
                filterParams: this.formatterService.defaultDateFilterParams,
                sortingOrder: ["desc", "asc", null],
                sort: "desc",
                minWidth: 140,
                maxWidth: 150
            },
            this.applicationNumberWithLinkColumn,
            this.transferorColumn,
            this.transfereeColumn,
            this.buildAssignedUserColumn(this.pendingReviewFilteredUsers),
            this.appTypeColumn
        ] as ColDef[];
    }

    public inspectionColDefs() {
        return [
            this.dateCreatedColumn,
            this.applicationNumberWithLinkInspectionColumn,
            this.inspectionStatusColumn,
            this.relatedApplicationColumn,
            this.transferorColumn,
            this.transfereeColumn,
            this.buildAssignedUserColumn(this.inspectionFilteredUsers),
            this.appTypeColumn,
        ] as ColDef[];
    }

    public firstReviewColDefs() {
        return [
            this.dateCreatedColumn,
            this.applicationNumberWithLinkColumn,
            this.transferorColumn,
            this.transfereeColumn,
            this.buildAssignedUserColumn(this.firstReviewFilteredUsers),
            this.appTypeColumn
        ] as ColDef[];
    }

    public finalReviewColDefs() {
        return [
            this.dateCreatedColumn,
            this.applicationNumberWithLinkColumn,
            this.transferorColumn,
            this.transfereeColumn,
            this.buildAssignedUserColumn(this.finalReviewFilteredUsers),
            this.appTypeColumn
        ] as ColDef[];
    }

    public approvedColDefs() {
        return [
            this.dateCreatedColumn,
            this.dateApprovedColumn,
            {
                headerClass: "wrapped",
                headerName: "Application Number",
                headerTooltip: "Application Number",
                field: 'flowIdentifier',
                tooltipField: 'flowIdentifier',
                filter: "agTextColumnFilter",
                filterParams: this.formatterService.defaultTextFilterParams,
                minWidth: 200,
                maxWidth: 225
            },
            this.transferorColumn,
            this.transfereeColumn,
            this.appTypeColumn
        ] as ColDef[];
    }

    public deniedColDefs() {
        return [
            this.dateCreatedColumn,
            this.dateDeniedColumn,
            {
                headerClass: "wrapped",
                headerName: "Application Number",
                headerTooltip: "Application Number",
                field: 'flowIdentifier',
                tooltipField: 'flowIdentifier',
                filter: "agTextColumnFilter",
                filterParams: this.formatterService.defaultTextFilterParams,
                minWidth: 200, 
                maxWidth: 225
            },
            this.transferorColumn,
            this.transfereeColumn,
            this.appTypeColumn
        ] as ColDef[];
    }

    refreshData(): void {
        let subs$ = this.getDataObs$().pipe(
            map(([notSubmittedRows, pendingRows, inspectionRows, firstReviewRows, finalReviewRows]) => {
                let inspectionGroups = this.groups.filter(g => this.groupHasPermission(g) && inspectionRows.map(r => r.assignedGroupId).findIndex(r => r == g.id) != null);
                let firstReviewGroups = this.groups.filter(g => this.groupHasPermission(g) && firstReviewRows.map(r => r.assignedGroupId).findIndex(r => r == g.id) != -1);
                let finalReviewGroups = this.groups.filter(g => this.groupHasPermission(g) && finalReviewRows.map(r => r.assignedGroupId).find(r => r == g.id) != null);
                let pendingReviewGroups = this.groups.filter(g => this.groupHasPermission(g) && finalReviewRows.map(r => r.assignedGroupId).find(r => r == g.id) != null)
                this.inspectionFilteredUsers = this.buildUserList(inspectionGroups);
                this.firstReviewFilteredUsers = this.buildUserList(firstReviewGroups);
                this.finalReviewFilteredUsers = this.buildUserList(finalReviewGroups);
                this.pendingReviewFilteredUsers = this.buildUserList(pendingReviewGroups);

            })
        ).subscribe({
            next: () => {
                this.inspectionGridApi.setGridOption("columnDefs", []);
                this.inspectionGridApi.setGridOption("columnDefs", this.inspectionColDefs());
                this.firstReviewGridApi.setGridOption("columnDefs", []);
                this.firstReviewGridApi.setGridOption("columnDefs", this.firstReviewColDefs());
                this.finalReviewGridApi.setGridOption("columnDefs", []);
                this.finalReviewGridApi.setGridOption("columnDefs", this.finalReviewColDefs());
                this.approvedGridApi.setGridOption("columnDefs", []);
                this.approvedGridApi.setGridOption("columnDefs", this.approvedColDefs());
                this.deniedGridApi.setGridOption("columnDefs", []);
                this.deniedGridApi.setGridOption("columnDefs", this.deniedColDefs());
                this.pendingGridApi.setGridOption("columnDefs", []);
                this.pendingGridApi.setGridOption("columnDefs", this.pendingColDefs());
            }, 
            error: (error) => {
                console.error(error);
            }
        });
        this.subscriptions.add(subs$);
    }

    onTabClicked(tab: TabComponent): void {
        this.notSubmittedGridApi.sizeColumnsToFit();
        this.pendingGridApi.sizeColumnsToFit();
        this.inspectionGridApi.sizeColumnsToFit();
        this.firstReviewGridApi.sizeColumnsToFit();
        this.finalReviewGridApi.sizeColumnsToFit();
        this.approvedGridApi.sizeColumnsToFit();
        this.deniedGridApi.sizeColumnsToFit();
    }

    setGridOptions(): void {
        this.notSubmittedGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.notSubmittedColDefs());
		this.notSubmittedGridOptions.onGridReady = (params) => { this.notSubmittedGridApi = params.api; };
        this.pendingGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.pendingColDefs());
        this.pendingGridOptions.onCellValueChanged = ($event) => this.saveAssignments($event);
		this.pendingGridOptions.onGridReady = (params) => { this.pendingGridApi = params.api; };
        this.inspectionGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.inspectionColDefs());
        this.inspectionGridOptions.onCellValueChanged = ($event) => this.saveAssignments($event);
		this.inspectionGridOptions.onGridReady = (params) => { this.inspectionGridApi = params.api; };
        this.firstReviewGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.firstReviewColDefs());
        this.firstReviewGridOptions.onCellValueChanged = ($event) => this.saveAssignments($event);
		this.firstReviewGridOptions.onGridReady = (params) => { this.firstReviewGridApi = params.api; };
        this.finalReviewGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.finalReviewColDefs());
        this.finalReviewGridOptions.onCellValueChanged = ($event) => this.saveAssignments($event);
		this.finalReviewGridOptions.onGridReady = (params) => { this.finalReviewGridApi = params.api; };
        this.approvedGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.approvedColDefs());
		this.approvedGridOptions.onGridReady = (params) => { this.approvedGridApi = params.api; };
		this.deniedGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.deniedColDefs());
		this.deniedGridOptions.onGridReady = (params) => { this.deniedGridApi = params.api; };
    }

    showLoadingOverlays(show: boolean): void {
        if (this.notSubmittedGridOptions && this.notSubmittedGridApi) {
            if (show) {
                this.notSubmittedGridApi.setGridOption("rowData", []);
                this.notSubmittedGridApi.setGridOption("loading", true);
            } else
                this.notSubmittedGridApi.setGridOption("loading", false);
        }

        if (this.pendingGridOptions && this.pendingGridApi) {
            if (show) {
                this.pendingGridApi.setGridOption("rowData", []);
                this.pendingGridApi.setGridOption("loading", true);
            } else
                this.pendingGridApi.setGridOption("loading", false);
        }

        if (this.inspectionGridOptions && this.inspectionGridApi) {
            if (show) {
                this.inspectionGridApi.setGridOption("rowData", []);
                this.inspectionGridApi.setGridOption("loading", true);
            }
            else
                this.inspectionGridApi.setGridOption("loading", false);
        }

        if (this.firstReviewGridOptions && this.firstReviewGridApi) {
            if (show) {
                this.firstReviewGridApi.setGridOption("rowData", []);
                this.firstReviewGridApi.setGridOption("loading", true);
            }
            else
                this.firstReviewGridApi.setGridOption("loading", false);
        }

        if (this.finalReviewGridOptions && this.finalReviewGridApi) {
            if (show) {
                this.finalReviewGridApi.setGridOption("rowData", []);
                this.finalReviewGridApi.setGridOption("loading", true);
            }
            else
                this.finalReviewGridApi.setGridOption("loading", false);
        }

        if (this.approvedGridOptions && this.approvedGridApi) {
            if (show) {
                this.approvedGridApi.setGridOption("rowData", []);
                this.approvedGridApi.setGridOption("loading", true);
            }
            else
                this.approvedGridApi.setGridOption("loading", false);
        }

        if (this.deniedGridOptions && this.deniedGridApi) {
            if (show) {
                this.deniedGridApi.setGridOption("rowData", []);
                this.deniedGridApi.setGridOption("loading", true);
            }
            else
                this.deniedGridApi.setGridOption("loading", false);
        }
    }

    getDataObs$(): Observable<[FlowIndex[], PendingFlow[], PendingFlow[], PendingFlow[], PendingFlow[], FlowIndex[], FlowIndex[]]> {
        this.showLoadingOverlays(true);

        let allUserSearchObs$ = this.groupService.get({ internal: true, stubs: false, fullContactDetails: true } as GroupSearchSpec);

        let notSubmittedObs$ = this.flowService.queryFlowIndices("WellTransferNotSubmitted", null).pipe(tap((result: FlowIndex[]) => {
            this.notSubmittedData = result
        }));

        let pendingItemObs$ = this.workOrderService.getPendingFlowsByTargetTransition("AllWellTransferWorkOrders", null).pipe(tap((result: PendingFlow[]) => {
            this.pendingData = result
        }));

        //This is here in case by Inspections, they mean actually duplicating inspections few
        const inspectionsSpec = {
            templateIds: PermitService.InspectionFlowTemplateIds,
            types: [WorkOrderType.Review],
            statuses: [WorkOrderStatus.Pending, WorkOrderStatus.Completed]
        } as WorkOrderSearchSpec;
        let inspectionSearchObs$ = this.workOrderService.getPendingFlows(inspectionsSpec, true).pipe(tap((data: PendingFlow[]) => {
            this.inspectionData = data.sort((a, b) => a.createdDate > b.createdDate ? 1 : -1);
        }));

        //For now, we're going with inspections shows items that have gotten past inspection and require permitting review
        //let inspectionSearchObs$ = this.workOrderService.getPendingFlowsByTargetTransition("WellTransferPermittingReviewWorkOrders").pipe(tap((data: PendingFlow[]) => {
       //     this.inspectionData = data;
       // }));

        let firstReviewSearchObs$ = this.workOrderService.getPendingFlowsByTargetTransition("WellTransferFirstReviewWorkOrders").pipe(tap((data: PendingFlow[]) => {
            this.firstReviewData = data;
        }));

        let finalReviewSearchObs$ = this.workOrderService.getPendingFlowsByTargetTransition("WellTransferFinalReviewWorkOrders").pipe(tap((data: PendingFlow[]) => {
            this.finalReviewData = data;
        }));

        let approvedObs$ = this.flowService.queryFlowIndices("WellTransferApproved", null).pipe(tap((data: FlowIndex[]) => {
            this.approvedData = data;
        }));

        let deniedObs$ = this.flowService.queryFlowIndices("WellTransferDenied", null).pipe(tap((data: FlowIndex[]) => {
            this.deniedData = data;
        }));

        let level1Subs$ = allUserSearchObs$.pipe(mergeMap((groupData) => {
            this.allUsers = [];
            this.inspectionFilteredUsers = [];
            this.firstReviewFilteredUsers = [];
            this.finalReviewFilteredUsers = [];
            this.pendingReviewFilteredUsers = [];
            if (groupData) {
                if (groupData instanceof Array) {
                    this.groups = groupData as Group[];
                    this.groups.forEach(g => this.allUsers = this.allUsers.concat(g.users));
                }
                this.allUsers = this.filterUniqueUsers(this.allUsers);
                this.allUsers.unshift({ id: "-1", displayName: "Unassigned" } as ContactStub);
            }
            return forkJoin(notSubmittedObs$, pendingItemObs$, inspectionSearchObs$, firstReviewSearchObs$, finalReviewSearchObs$, approvedObs$, deniedObs$);
        }));
        return level1Subs$;
    }

    cellValueChanged(params: any): void {
        if (params.api) {
            params.api.refreshCells();
        }
    }

    buildUserList(groups: Group[]): ContactStub[] {
        let userList: ContactStub[] = [];
        groups.forEach(u => userList = userList.concat(u.users));
        userList = this.filterUniqueUsers(userList);
        userList = this.sortUsers(userList);
        userList.unshift({ id: "-1", displayName: "Unassigned" } as ContactStub);
        return userList;
    }

    filterUniqueUsers(users: ContactStub[]): ContactStub[] {
        return users.filter((user, i, arr) => arr.findIndex(t => t.id === user.id) === i);
    }

    sortUsers(users: ContactStub[]): ContactStub[] {
        return users.sort((a, b) => {
            if (a.firstName > b.firstName) return 1;
            if (a.firstName < b.firstName) return -1;
            if (a.firstName == b.firstName) {
                if (a.lastName > b.lastName) return 1;
                if (a.lastName < b.lastName) return -1;
            }
            return 0;
        })
    }

    saveAssignments(event: any): void {
        const changedItem = event.data as PendingFlow;
        const pending = new PendingWorkOrderAssignment(changedItem?.currentWorkItemId ?? "", changedItem.assignedUserId, changedItem.assignedUserName, true, changedItem.flowId);
        const sub$ = this.workOrderService.assignWorkOrder(pending)
            .subscribe({
                next: () => { },
                error: (error: any) => { console.error(error); }
            });
        this.subscriptions.add(sub$);
    }

    assign = (params: any): boolean => {
        if (params && params.newValue && params.newValue.id) {
            params.data.assignedUserId = params.newValue.id !== "-1" ? params.newValue.id : "";
            const selectedItem = this.allUsers.find(u => u.id === params.newValue.id);
            params.data.assignedUserName = selectedItem?.displayName ?? "";
            return true;
        }
        return false;
    }

    renderUserDropdownOptions(params: any): string {
        let returnValue = params && params.value && params.value.displayName ? params.value.displayName : "Unassigned";
        return returnValue;
    }

    renderAssignedUser(params: any): string {
        return params?.value?.displayName ?? "Unassigned";
    }

    buildAssignedUserColumn(contacts: ContactStub[]): ColDef {
        return {
            headerName: "Assignee",
            headerTooltip: "Assignee",
            field: "assignedUserId",
            suppressFiltersToolPanel: true,
            suppressMovable: true,
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: true,
            cellEditorParams: {
                formatValue: (value: any) => value?.displayName ?? 'Unassigned',
                values: contacts
            },
            cellRenderer: this.renderAssignedUser,
            valueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedUserId) ?? null,
            filterValueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedUserId)?.displayName ?? 'Unassigned',
            valueSetter: this.assign,
            tooltipValueGetter: this.renderAssignedUser,
            minWidth: 150,
            onCellValueChanged: this.cellValueChanged
        } as ColDef;
    }

}
